module.exports = __webpack_public_path__ + "media/images/logo-ad2a3b02f059c15fea04061cfcfc2177.png";